<template>
  <div v-if="customer">
    <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
      <LcbftAlert :lcbftScore="customer.lcbftScore" :lcbftRegistryId="customer.lcbftRegistryId" />

      <h3 class="text-lg sm:text-xl font-semibold text-gray-800 mb-4">
        {{ customer.firstName }} {{ customer.lastName }}
      </h3>

      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2">
        <div class="space-y-2">
          <StackedField label="Email" :value="customer.email" />
          <StackedField label="Téléphone" :value="customer.phone" />
        </div>
        <div class="space-y-2">
          <StackedField label="Date de naissance" :value="customer.birthDate" />
          <StackedField label="Lieu de naissance" :value="customerBirthPlace" />
        </div>
        <div class="space-y-2">
          <StackedField label="Adresse" :value="customer.fullAddress" />
          <CopyableFieldRow v-if="customer.signUpUrl" label="Création du compte" :value="customer.signUpUrl" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { StackedField, CopyableFieldRow } from "@estaly/ui";
import LcbftAlert from "@/components/plan_sale/LcbftAlert.vue";

export default {
  components: {
    StackedField,
    CopyableFieldRow,
    LcbftAlert,
  },

  props: ["customer"],

  computed: {
    customerBirthPlace() {
      return [this.customer.birthCity, this.customer.birthCountry].filter(Boolean).join(", ");
    },
  },
};
</script>
